var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_21684",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 45
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_21684)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.9813 11.25V33.75C40.9813 34.123 40.8332 34.4806 40.5694 34.7444C40.3057 35.0081 39.948 35.1562 39.5751 35.1562H28.3251C26.8332 35.1562 25.4025 35.7489 24.3476 36.8038C23.2927 37.8587 22.7001 39.2894 22.7001 40.7812C22.7001 39.2894 22.1074 37.8587 21.0525 36.8038C19.9977 35.7489 18.5669 35.1562 17.0751 35.1562H5.82507C5.45211 35.1562 5.09443 35.0081 4.8307 34.7444C4.56698 34.4806 4.41882 34.123 4.41882 33.75V11.25C4.41882 10.877 4.56698 10.5194 4.8307 10.2556C5.09443 9.99191 5.45211 9.84375 5.82507 9.84375H17.0751C18.5669 9.84375 19.9977 10.4364 21.0525 11.4913C22.1074 12.5462 22.7001 13.9769 22.7001 15.4688C22.7001 13.9769 23.2927 12.5462 24.3476 11.4913C25.4025 10.4364 26.8332 9.84375 28.3251 9.84375H39.5751C39.948 9.84375 40.3057 9.99191 40.5694 10.2556C40.8332 10.5194 40.9813 10.877 40.9813 11.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5751 8.4375H28.3251C27.2335 8.4375 26.1569 8.69165 25.1806 9.17981C24.2043 9.66797 23.355 10.3767 22.7001 11.25C22.0451 10.3767 21.1959 9.66797 20.2195 9.17981C19.2432 8.69165 18.1666 8.4375 17.0751 8.4375H5.82507C5.07915 8.4375 4.36378 8.73382 3.83634 9.26126C3.30889 9.78871 3.01257 10.5041 3.01257 11.25V33.75C3.01257 34.4959 3.30889 35.2113 3.83634 35.7387C4.36378 36.2662 5.07915 36.5625 5.82507 36.5625H17.0751C18.194 36.5625 19.267 37.007 20.0582 37.7981C20.8493 38.5893 21.2938 39.6624 21.2938 40.7812C21.2938 41.1542 21.442 41.5119 21.7057 41.7756C21.9694 42.0393 22.3271 42.1875 22.7001 42.1875C23.073 42.1875 23.4307 42.0393 23.6944 41.7756C23.9582 41.5119 24.1063 41.1542 24.1063 40.7812C24.1063 39.6624 24.5508 38.5893 25.342 37.7981C26.1331 37.007 27.2062 36.5625 28.3251 36.5625H39.5751C40.321 36.5625 41.0364 36.2662 41.5638 35.7387C42.0913 35.2113 42.3876 34.4959 42.3876 33.75V11.25C42.3876 10.5041 42.0913 9.78871 41.5638 9.26126C41.0364 8.73382 40.321 8.4375 39.5751 8.4375ZM17.0751 33.75H5.82507V11.25H17.0751C18.194 11.25 19.267 11.6945 20.0582 12.4856C20.8493 13.2768 21.2938 14.3499 21.2938 15.4688V35.1562C20.0779 34.2411 18.5968 33.7474 17.0751 33.75ZM39.5751 33.75H28.3251C26.8033 33.7474 25.3222 34.2411 24.1063 35.1562V15.4688C24.1063 14.3499 24.5508 13.2768 25.342 12.4856C26.1331 11.6945 27.2062 11.25 28.3251 11.25H39.5751V33.75Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_21684)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.199951,
    width: 45,
    height: 45,
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_21684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.199951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.0be1df8a4ef7ba732f06522462fb7fad.svg";
export { ForwardRef as ReactComponent };